import { gql, useQuery } from '@provision/graphql-client';
import { MentionItem } from '@provision/rich-text-editor';

import useDebouncedValue from 'src/utils/hooks/use-debounced-value';

const ITEMS_LIMIT = 10;

interface GetMentionOptionsQueryResult {
  getMentionOptions: {
    records: MentionItem[];
  };
}

export const GET_MENTIONS_OPTIONS_QUERY = gql`
  query GetMentionOptions($params: GetMentionOptionsInput) {
    getMentionOptions(params: $params) {
      records {
        id
        label
        entity
        assigneeGroupId
        assigneeGroupName
      }
    }
  }
`;

export function useMentionsOptions(params: {
  searchTerm: string;
  categories: string[];
  partnerId?: number | null;
}) {
  const searchTerm = useDebouncedValue(params.searchTerm, 500);

  const { categories, partnerId } = params;

  const { data, ...rest } = useQuery<GetMentionOptionsQueryResult>(
    GET_MENTIONS_OPTIONS_QUERY,
    {
      fetchPolicy: 'no-cache',
      skip: !categories.length,
      variables: {
        params: {
          partnerId: partnerId!,
          limit: ITEMS_LIMIT,
          categories,
          ...(searchTerm && { searchTerm }),
        },
      },
    },
  );

  return {
    records: data?.getMentionOptions?.records ?? [],
    ...rest,
    isLoading: rest.loading,
  };
}
